import { Box } from "@chakra-ui/react";

export default function EquationMaker() {
  return <Box></Box>;
}

function ValueDisplay({ setValue }: { setValue: (value: string) => void }) {}

interface ValueToken {}
